const axios = require('@/utils/axios')
import Vue from 'vue'
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	categories : [],
	current_category : null,
}

const getters = {
	fetchCategories : (state) => state.categories,
	fetchCurrentCategory : (state) => state.current_category,
}

const actions = {
	loadCategories({commit}, {token, filter, do_commit=true}){
		const query_arr = []
		for(let key in filter){
			if(filter[key]){
				query_arr.push(`${key}=${encodeURIComponent(filter[key])}`)	
			}
		}
		const query_str = query_arr.join('&')
		return $http.get(`category?${query_str}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			if(do_commit){
				commit('SET_CATEGORIES', response.data)
			}else{
				return response
			}
			
		})
	},

	emptyCurrentCategory({commit}){
		commit('SET_CURRENT_CATEGORY', null)
	},

	loadCategoryDetails({commit}, {id, token}){
		return $http.get(`category/${id}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_CATEGORY', response.data)
		})
	},

	createCategory({commit}, {category, token}){
		// let category_formdata = new FormData()
		// for(let key in category){
		// 	if(key == 'categoryfiles'){
		// 		for(let i in category[key]){
		// 			category_formdata.append(`${key}`, category[key][i])
		// 		}
		// 	}else{
		// 		category_formdata.append(key, category[key])
		// 	}	
		// }
		for(let key in category){
			if(category[key] == null){
				delete category[key]
			}
		}
		
		return $http.post('category', category, {
			headers : {
				// 'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('ADD_CATEGORY', response.data)
		})
	},

	updateCategory({commit}, {id, category, token}){
		// let category_formdata = new FormData()
		// for(let key in category){
		// 	if(key == 'categoryfiles'){
		// 		for(let i in category[key]){
		// 			category_formdata.append(`${key}`, category[key][i])
		// 		}
		// 	}else if(key == 'editfiles'){
		// 		category_formdata.append(key, JSON.stringify(category[key]))
		// 	}else{
		// 		category_formdata.append(key, category[key])
		// 	}	
		// }

		for(let key in category){
			if(category[key] == null){
				delete category[key]
			}
		}
		
		return $http.put(`category/${id}`, category, {
			headers : {
				// 'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('UPDATE_CATEGORY', response.data)
		})
	},

	deleteCategory({commit}, {id, token}){
		return $http.delete(`category/${id}`, {
			headers : {
				'x-auth-token' : token
			} 
		}).then(() => {
			commit('REMOVE_CATEGORY', id)	
		})
	},

	lockUnlockCategory({commit}, {data, token}){
		return $http.put(`classroom-category`, data, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('UPDATE_CATEGORY', response.data)
		})
	},
}

const mutations = {
	SET_CATEGORIES : (state, categories) => {
		state.categories = categories
	},
	SET_CURRENT_CATEGORY : (state, category) => {
		state.current_category = category
	},
	ADD_CATEGORY : (state, category) => {
		state.categories.push(category)
	},
	UPDATE_CATEGORY : (state, category) => {
		state.current_category = category
		let cat_index = state.categories.findIndex(category_obj => category_obj._id == category._id)
		Vue.set(state.categories, cat_index, Object.assign({}, category)) // For making it reactive
	},
	REMOVE_CATEGORY : (state, category_id) => {
		state.categories = state.categories.filter(category => category._id != category_id)
		if(state.current_category && (state.current_category._id == category_id)){
			state.current_category = null
		}
	},
}

export default {
	state, getters, actions, mutations
}